export default function Badge({ children, variant = '', style = {} }) {
  return (
    <span className={`b ${variant}`} style={style}>
      {children}
    </span>
  );
}
